import { Operation } from '@apollo/client';
import { RetryLink } from '@apollo/client/link/retry';

export function operationHasQueriesOnly(operation: Operation) {
  return !operation.query.definitions.some((def) => {
    if (def.kind === 'OperationDefinition' && def.operation === 'mutation') {
      return true;
    }
  });
}

export default function (maxRetries: number): RetryLink {
  return new RetryLink({
    attempts: {
      max: maxRetries,
      retryIf: (error, operation) => {
        return error && operationHasQueriesOnly(operation);
      },
    },
  });
}
